<section class="px-6 py-20 sm:px-10">
  <div class="mx-auto max-w-md">
    @switch (state()) {
      @case ('loading') {
        <div class="rounded-md border border-hairline bg-panel p-9 text-center">
          <span class="mb-4 block text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-gold"
            >One moment</span
          >
          <h1 class="font-display text-2xl font-semibold text-parchment">Verifying your email…</h1>
        </div>
      }
      @case ('success') {
        <div class="rounded-md border border-gold-dim bg-panel p-9 text-center">
          <span class="mb-4 block text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-gold"
            >Verified</span
          >
          <h1 class="font-display text-2xl font-semibold text-parchment">You're all set</h1>
          <p class="mt-3 text-dusk">Your email is verified — you can log in now.</p>
          <a
            routerLink="/login"
            class="mt-7 inline-flex items-center justify-center rounded-[3px] bg-gradient-to-b from-gold to-gold-dim px-6 py-3 text-sm font-bold text-ink transition hover:-translate-y-px"
            >Go to Log In</a
          >
        </div>
      }
      @case ('missing-token') {
        <div class="rounded-md border border-wax/40 bg-panel p-9 text-center">
          <span class="mb-4 block text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-gold"
            >Missing link</span
          >
          <h1 class="font-display text-2xl font-semibold text-parchment">
            That verification link looks incomplete
          </h1>
          <p class="mt-3 text-dusk">
            Copy the full link from your email, or log in to see if it already went through.
          </p>
          <a
            routerLink="/login"
            class="mt-7 inline-flex items-center justify-center rounded-[3px] border border-hairline px-6 py-3 text-sm font-semibold text-parchment transition hover:border-parchment"
            >Go to Log In</a
          >
        </div>
      }
      @default {
        <div class="rounded-md border border-wax/40 bg-panel p-9 text-center">
          <span class="mb-4 block text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-gold"
            >Link expired?</span
          >
          <h1 class="font-display text-2xl font-semibold text-parchment">
            That link is invalid or has expired
          </h1>
          <p class="mt-3 text-dusk">
            Verification links last 24 hours. Try logging in — if you're not verified yet,
            we'll let you know there too.
          </p>
          <a
            routerLink="/login"
            class="mt-7 inline-flex items-center justify-center rounded-[3px] border border-hairline px-6 py-3 text-sm font-semibold text-parchment transition hover:border-parchment"
            >Go to Log In</a
          >
        </div>
      }
    }
  </div>
</section>
